<h1 class="email-form-title text-primary-blue-700">Log In</h1>
<div *ngIf="errorMessage">
  <app-message severity="error" [noMargin]="true" data-cy="login-error-message">
    {{ errorMessage }}
  </app-message>
</div>
<form [formGroup]="sendCodeForm" (ngSubmit)="onSubmit()" formId="sendCodeForm" data-cy="login-email-form">
  <app-form-field
    [control]="asFormControl(sendCodeForm.get('username'))"
    name="username"
    label="Email"
    type="input"
  ></app-form-field>
  <app-form-field
    [control]="asFormControl(sendCodeForm.get('factor'))"
    class="factor"
    name="factor"
    type="radio"
    [options]="[
      { label: 'Send code by email', value: 'email' },
      { label: 'Send code by text to mobile number on file', value: 'phone' }
    ]"
  ></app-form-field>
  <app-form-footer
    [disabled]="disableButton"
    submitLabel="Send Sign-In Code"
    [noCancel]="true"
    [fullWidthButtons]="true"
  >
  </app-form-footer>
  <app-separator class="divider" text="OR"></app-separator>
  <button
    pButton
    type="button"
    label="Use Password"
    class="p-button-outlined w-full password-button"
    (click)="onUsePassword()"
    data-cy="use-password-button"
  ></button>
  <a class="link" (click)="forgotPassword()">Forgot Your Password?</a>
  <p class="inline-link">
    Don't have an account? <a [routerLink]="['/login/new']" class="inner-link no-underline">Sign Up</a>
  </p>
  <app-mobile-footer></app-mobile-footer>
</form>
